export const ACCOUNT_LIST = {
  ADDRESSES: 'addresses',
  OFFERS: 'offers',
  ORDERS: 'orders',
  PAYMENTS: 'payments',
  PREFERENCES: 'preferences',
  PROFILE: 'profile',
  SUPPORT: 'support',
  WANTS: 'wants',
};

export const OTP_METHODS = { EMAIL: 'email', PHONE: 'phone' };
